export default __webpack_public_path__ + "media/images/mailer/wordmark-b7737ce06c833491e72a99478797cc23.png";